import { DataSourceOrigin } from '@/pages/ingestion/loadData/selectSource/SelectSourceOrigin';
import { InitialContentState } from '@/utils/analytics/types';

/**
 * Remembers, for the lifetime of the tab, which data source each in-flight solution install
 * was created with.
 *
 * The install runs on the backend and the solution instance the poller reads back does not
 * echo `data_source_origin`, but EVT-006 needs it to say whether the graph landed with data
 * or with a schema alone. Only the wizard that started the install knows, so it records the
 * answer here and the poller consumes it when the install completes.
 */
const originBySolutionId = new Map<string, DataSourceOrigin>();

export function recordSolutionInstallOrigin(solutionId: string, origin: DataSourceOrigin) {
  originBySolutionId.set(solutionId, origin);
}

/**
 * The content a completed solution install left in the graph.
 *
 * A solution kit always commits its schema. Whether it also loads data depends on the origin
 * the user picked. When the origin is unknown — the install was started before a reload, or
 * in another tab — we report the part we can stand behind rather than guessing that data
 * arrived.
 */
export function takeSolutionInitialContentState(solutionId: string): InitialContentState {
  const origin = originBySolutionId.get(solutionId);
  originBySolutionId.delete(solutionId);
  return origin === 'sample' || origin === 'cloud' ? 'schema_and_data' : 'schema_only';
}
